import { Typography } from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";

import { TAccount, TMyClass } from "../../../../../@types";
import noAvatarImage from "../../../../imagenes/no_avatar.svg";
import { useAccount } from "../../../../../hooks/useAccount";

export type TUpcomingAppointmentItemProps = {
	upcomingAppointment: TMyClass;
};

export function UpcomingAppointmentItem(props: TUpcomingAppointmentItemProps) {
	const { account } = useAccount();
	let opponent: TAccount | undefined;
	let syllabusLink = "";
	if (account?.id === props.upcomingAppointment.userId) {
		opponent = props.upcomingAppointment.lesson.course?.teacher;
		syllabusLink = `/learning/${props.upcomingAppointment.lesson.course.courseSlug}?class=${props.upcomingAppointment.id}`;
	} else if (account?.id === props.upcomingAppointment.teacherId) {
		opponent = props.upcomingAppointment.user;
		syllabusLink = `/teaching/${props.upcomingAppointment.lesson.course.courseSlug}/${props.upcomingAppointment.userId}?class=${props.upcomingAppointment.id}`;
	}

	if (!opponent) {
		return null;
	}

	return (
		<div className="upcoming-appointment-container">
			<div className="time-container">
				<Typography className="big-text bold">
					{moment(props.upcomingAppointment.startTime).format("ddd")}
				</Typography>
				<Typography className="normal-text">
					{moment(props.upcomingAppointment.startTime).format("MMM DD")}
				</Typography>
				<Typography className="big-text bold">
					{moment(props.upcomingAppointment.startTime).format("HH:mm")}
				</Typography>
			</div>
			<div className="appointment-info-container">
				<div className="user-info-container">
					<img
						src={
							opponent.profile?.thumbnail ||
							opponent.profile?.url ||
							noAvatarImage
						}
						className="avatar"
					/>
					<div>
						<Typography className="normal-text bold">
							{opponent.firstName}
						</Typography>
						<Typography className="normal-text">
							{props.upcomingAppointment.lesson.title}
						</Typography>
					</div>
				</div>
				<div className="buttons-group-container">
					<Link
						to={`/messages/${opponent.userId}`}
						className="appointment-button no-underline-link black-text">
						<Typography className="normal-text" textAlign="center">
							{`Message ${opponent.firstName}`}
						</Typography>
					</Link>
					<div className="button-separator" />
					<Link
						to={syllabusLink}
						className="appointment-button no-underline-link black-text">
						<Typography className="normal-text" textAlign="center">
							View Syllabus
						</Typography>
					</Link>
				</div>
			</div>
		</div>
	);
}
